import ABCyaPhaser from '@abcya/abcya_phaser';
import ABCyaLib from '@abcya/abcya_lib';
import Phaser from 'phaser'
import FontKeys from '../FontKeys';
import gameData from '../gameData';
import PercentageBar, { TIMER_DONE } from '../gameobjects/PercentageBar';
import Santa from '../gameobjects/Santa';
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';
import MathResults from './MathResults';
import { OPERATIONS } from './SelectLevel';

export default class QuizGame extends Phaser.Scene
{
    static get KEY() { return 'QuizGame'; }

    constructor()
    {
        super({ key: (QuizGame).KEY });
    }

    create()
    {
        const { gameConfig } = ABCyaLib.Environment.instance;

        gameData.correctAnswers = 0;
        gameData.wrongAnswers = 0;

        this._topBg = this.add.rectangle(0, 0, this.scale.width, 429, 0x223e63).setOrigin(0);
        this._bottomBg = this.add.rectangle(0, this._topBg.height, this.scale.width, this.scale.height - this._topBg.height, 0x0f75bc).setOrigin(0);

        // answer white box
        this.add.graphics({ fillStyle: 0xffffff }).fillRoundedRect(this.scale.width / 2 + 100, this.scale.height / 2 - 160, 196, 120, 10);

        this.santa = new Santa(this, this.scale.width / 2 + 203, this.scale.height / 2 - 205).setScale(0.45);
        this.santa.rightArm.angle = -40;

        this.currentTextLabel = ABCyaPhaser.Text.addText(this.scale.width / 2 + 198, this.scale.height / 2 - 95, 100, 0x000000, FontKeys._odin_roundedregular, "", this, true);

        for (let i = 0; i < 10; i++)
        {
            const b = ABCyaPhaser.Buttons.addSimpleButton((this.scale.width / 2 - 425) + (i % 5) * 150, this.scale.height / 2 + 125 + (Math.floor(i / 5) * 150), 'sprites/' + i + '_button', null, this.handleKeyHit.bind(this), this, { pressAnimationConfig: { scale: 0.9 }, releaseAnimationConfig: { scale: 1 } });
            b.value = i;
        }

        this.enterButton = this.add.container(this.scale.width / 2 + 390, this.scale.height / 2 + 125);
        const enterBtnBg = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._sprites_enter_button, this.enterButton);
        ABCyaPhaser.Container.setContainerInteractive(this.enterButton);

        const enterBtnText = ABCyaPhaser.Text.addText(0,-3, gameConfig.quizEnterButtonFontSize, 0xffffff, FontKeys._asapbold, ABCyaPhaser.Localization.instance.getLocalizedString("math_fact_fun.enter_button"), this.enterButton, true).setOrigin(0.5);
        ABCyaPhaser.Buttons.convertToButton(this.enterButton, {onClick:  this.handleKeyHit.bind(this),  pressAnimationConfig: { scale: 0.9 }, releaseAnimationConfig: { scale: 1 } })

        this.clearButton = this.add.container(this.scale.width / 2 + 390, this.scale.height / 2 + 275);
        const clearBtnBg = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._sprites_clear_button, this.clearButton);
        ABCyaPhaser.Container.setContainerInteractive(this.clearButton);

        const clearBtnText = ABCyaPhaser.Text.addText(0,-3, gameConfig.quizClearButtonFontSize, 0xffffff, FontKeys._asapbold, ABCyaPhaser.Localization.instance.getLocalizedString("math_fact_fun.clear_button"), this.clearButton, true).setOrigin(0.5);
        ABCyaPhaser.Buttons.convertToButton(this.clearButton, {onClick:  this.handleKeyHit.bind(this),  pressAnimationConfig: { scale: 0.9 }, releaseAnimationConfig: { scale: 1 } })

        this.currentProblemLabel = ABCyaPhaser.Text.addText(this.scale.width / 2 + 80, this.scale.height / 2 - 95, 110, 0xffffff, FontKeys._odin_roundedregular, "", this, false).setOrigin(1, 0.5);

        this.generateProblem();

        this.percentageBar = new PercentageBar(this, this.scale.width / 2 - 260, 75);
        this.percentageBar.start();

        this.percentageBar.once(TIMER_DONE, this.timerDone, this);

        let levelString = this.getLevelString();

        this.levelLabel = ABCyaPhaser.Text.addText(this.scale.width / 2 - 445, 20, 38, 0xffffff, FontKeys._odin_roundedregular, levelString, this, false);

        this.correctLabel = ABCyaPhaser.Text.addText(this.scale.width / 2, this.scale.height / 2, 60, 0x00ff00, FontKeys._odin_roundedregular, ABCyaPhaser.Localization.instance.getLocalizedString("math_fact_fun.correct_response"), this, true).setVisible(false);

        this.wrongLabel = ABCyaPhaser.Text.addText(this.scale.width / 2, this.scale.height / 2, 60, 0xff0000, FontKeys._odin_roundedregular, ABCyaPhaser.Localization.instance.getLocalizedString("math_fact_fun.incorrect_response"), this, true).setVisible(false);
    }

    generateProblem()
    {
        let maxOp = 8;

        switch (gameData.difficulty)
        {
            case 1:
                maxOp = 8;
                break;
            case 2:
                maxOp = 12;
                break;
            case 3:
                maxOp = 15;
                break;
        }

        let op1 = Phaser.Math.Between(1, maxOp);
        let op2 = Phaser.Math.Between(1, maxOp);

        this.currentCorrectAnswer = 0;
        this.currentProblemString = "";

        switch (gameData.operation)
        {
            case OPERATIONS.plus:
                this.currentProblemString = op1 + " + " + op2 + " = ";
                this.currentCorrectAnswer = op1 + op2;
                break;

            case OPERATIONS.minus:
                // avoid negative numbers
                if (op1 >= op2)
                {
                    this.currentProblemString = op1 + " - " + op2 + " = ";
                    this.currentCorrectAnswer = op1 - op2;
                }
                else
                {
                    this.currentProblemString = op2 + " - " + op1 + " = ";
                    this.currentCorrectAnswer = op2 - op1;
                }
                break;
            case OPERATIONS.times:
                this.currentProblemString = op1 + " X " + op2 + " = ";
                this.currentCorrectAnswer = op1 * op2;
                break;
            case OPERATIONS.divide:
                let tot = op1 * op2;
                this.currentProblemString = tot + " / " + op1 + " = ";
                this.currentCorrectAnswer = op2;
                break;
        }

        this.currentProblemLabel.text = this.currentProblemString;
    }

    getLevelString()
    {
        let level = ABCyaPhaser.Localization.instance.getLocalizedString("math_fact_fun.level_header") + " ";

        switch (gameData.difficulty)
        {
            case 1:
                level += "1";
                break;
            case 2:
                level += "2";
                break;
            case 3:
                level += "3";
                break;
        }

        let oper = "";

        switch (gameData.operation)
        {
            case OPERATIONS.plus:
                oper = ABCyaPhaser.Localization.instance.getLocalizedString("math_fact_fun.subjects.addition");
                break;
            case OPERATIONS.minus:
                oper = ABCyaPhaser.Localization.instance.getLocalizedString("math_fact_fun.subjects.subtraction");
                break;
            case OPERATIONS.times:
                oper = ABCyaPhaser.Localization.instance.getLocalizedString("math_fact_fun.subjects.multiplication");
                break;
            case OPERATIONS.divide:
                oper = ABCyaPhaser.Localization.instance.getLocalizedString("math_fact_fun.subjects.division");
                break;
        }

        return oper + " | " + level;
    }

    handleKeyHit(button)
    {
        if (button === this.enterButton)
        {
            this.checkTheAnswer();
        }
        else if (button === this.clearButton)
        {
            ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this);
            this.currentTextLabel.text = "";
        }
        else
        {
            ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this);

            if (this.currentTextLabel.text.length < 3)
            {
                this.currentTextLabel.text += button.value;

                // remove starting 0s (so that the number can't be 02 or 00 for example)
                if (this.currentTextLabel.text.length > 1)
                {
                    this.currentTextLabel.text = this.currentTextLabel.text.replace(/^0/g, '');
                }
            }
        }
    }

    checkTheAnswer()
    {
        this.tweens.timeline(
            {
                tweens:
                    [
                        ABCyaPhaser.Tweens.createTween(this.currentProblemLabel, 100, { scale: 1.2 }, Phaser.Math.Easing.Quadratic.Out),
                        ABCyaPhaser.Tweens.createTween(this.currentProblemLabel, 100, { scale: 1 }, Phaser.Math.Easing.Quadratic.Out),
                    ],
                onComplete: this.generateProblem,
                onCompleteScope: this
            }
        );

        if ((this.currentCorrectAnswer + "") == this.currentTextLabel.text)
        {
            this.santa.rightAnimation();

            ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._correct, this);

            gameData.correctAnswers++;

            this.correctLabel.setVisible(true);

            this.time.delayedCall(750, this.correctLabelBlanked, null, this);
        }
        else
        {
            this.santa.wrongAnimation();

            ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._incorrect, this);

            gameData.wrongAnswers++;

            this.wrongLabel.setVisible(true);

            this.time.delayedCall(750, this.wrongLabelBlanked, null, this);
        }

        this.currentTextLabel.text = "";
    }

    wrongLabelBlanked()
    {
        this.wrongLabel.setVisible(false);
    }

    correctLabelBlanked()
    {
        this.correctLabel.setVisible(false);
    }

    timerDone()
    {
        this.leave();
    }

    leave()
    {
        this.scene.start(MathResults.KEY);
    }
}